/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This abstract class implements IDocumentServiceFactory interface. It uses delegation pattern.
 * It delegates all calls to IDocumentServiceFactory implementation passed to constructor.
 */
export class DocumentServiceFactoryProxy {
    constructor(_serviceFactory) {
        this._serviceFactory = _serviceFactory;
    }
    get serviceFactory() {
        return this._serviceFactory;
    }
    async createContainer(createNewSummary, createNewResolvedUrl, logger, clientIsSummarizer) {
        return this.serviceFactory.createContainer(createNewSummary, createNewResolvedUrl, logger, clientIsSummarizer);
    }
    async createDocumentService(resolvedUrl, logger, clientIsSummarizer) {
        return this.serviceFactory.createDocumentService(resolvedUrl, logger, clientIsSummarizer);
    }
}
//# sourceMappingURL=documentServiceFactoryProxy.js.map